//记得在 src\components\lang\zhLoad.js 里面添加对象
const client = {
  cs:'客服',
  mdCounterData:'柜台主数据缺失',
  ticketUntreated: '差异未处理',
  bc: '柜台',
  stayReceived: '待收货',
  stayInspection: '待验货',
  ticketPending: '差异待处理',
  ticketFinish: '差异已处理',
  pendingApproval: '待审批',
  carrier: '货运公司',
  waitForLoading: '待装车确认',
  modifiedReqArriveTimeTitle: '柜台要求送货日',
  waitArrived: '待送达确认',
  warehouse: '仓库',
  updateApprove: '修改审批',
  overdueDiff: '超期差异处理',
  msg: {
  }
};
export default client



// WEBPACK FOOTER //
// ./src/page/md/plantArea/lang/index.zh.js